/**
 * @title extendedaddtocart.js: Sub-module of Browse feature
 * @description This module encapsulates all of the
 * functionality related to the add to cart component in Search and PLP pageS.
 */
define(['addToCartStateHandler', 'addToCartProductObject', 'addToCartDataHandler', 'addToCartUIHandling', 'productRedirectHelper'],
function(addToCartStateHandler, addToCartProductObject, addToCartDataHandler, addToCartUIHandling, productRedirectHelper) {
    let ExtendedAddToCart = {
        maxQuantity: null,
        /**
         * The initializing function modules use
         * to call.
         */
        init: () => {
            COSTCO.Header.miniShopCartRefresh();
             COSTCO.Header.refreshGroceryBanner();
            ExtendedAddToCart.maxQuantity = COSTCO.util.isBDStore() ? Number($('#cartTotalLimitSearch').val()) : 999;
            setTimeout(ExtendedAddToCart.compareProductsClearfix, 1000);
        },
        /**
         * Method to redirect to PDP on click of product image or product name
         */
        redirectToPage: productRedirectHelper.redirectToPage,
        /**
         * Checks the maximum and minimum quantity limit for item on click
         * of +/- or direct input
         * @param {e} e 
         */
        handleQuantityLimit: function(formObject, flag){
            const minQty = parseInt($(formObject).find('.minQuantity').val());
            const maxQty = parseInt($(formObject).find('.maxQuantity').val());
            const quantity = parseInt($(formObject).find('.product-quick-buy-txt .form-control').val());
            if(typeof messages != 'undefined'){
            	let invalidMessage = '', errorMessage = '';
                if(!flag && quantity <= minQty) {
                    errorMessage = messages['ERR_ADD_TO_CART_INVALID_QTY'];
                    if(typeof errorMessage != 'undefined'){
                        invalidMessage = errorMessage.replace('{0}',minQty);
                        addToCartUIHandling.showError(formObject, invalidMessage);
                        return true;   
                    }
                } else if(flag && quantity >= maxQty) {
                    errorMessage = messages['ERR_ADD_TO_CART_HIGHER_QTY_2'];
                    if(typeof errorMessage != 'undefined'){
                        invalidMessage = errorMessage.replace('{0}',maxQty);
                        addToCartUIHandling.showError(formObject, invalidMessage);
                        return true;
                    }
                }
            }
            return false;
        },
        /**
         * this is a helper method to only allow numbers
         * in the quantity selector
         * @param {e} e
         */
        quantityValidation: function(e) {
            e.stopImmediatePropagation();
            const inputField = $(e.currentTarget);
            const inputValue = inputField.val();
            const scrubbedInputValue = inputValue.replace(/[^0-9]/gi, '');
            $(inputField).val(scrubbedInputValue);
            const formObject = inputField.closest('form');
            addToCartStateHandler.setDefaultState(formObject);
        },

        catchEnterKey: function(event) {
            if(event.keyCode == 13)
                $(event.currentTarget).blur();
        },

        /**
         * This is called when the +/- button
         * is clicked on the Search / PLP page
         * @param  {Event} event
         * @param  {Number} index - index of the product being added
         * @param  {Number} partNumber - partNumber of the product being added
         * @param  {Number} sku - sku of the product being added
         * @param  {Boolean} isIncrement - true if + button is clicked, false if - button is clicked.
         */

        handleAddCartQty: function(event, index, partNumber, sku, isIncrement) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const currentTarget = event.currentTarget == null ? 
                $(event.target) : $(event.currentTarget);
            const formObject = currentTarget.closest('form[name=OrderItemAddForm]');
            const addToCartDivWrapper = formObject.find('.product-quick-buy-btn');
            const productAddedToCart = addToCartDivWrapper.css('display') === 'none';
            if(this.handleQuantityLimit(formObject, isIncrement)){
            	return false;
            }        
            if(productAddedToCart) {
                this.handleQuantityChange(formObject, isIncrement);
                this.updateItemToCart(event, formObject, partNumber, sku, isIncrement, index);
            } else {
                this.handleQuantityChange(formObject, isIncrement);
            }
        },

        /**
         * Sets the UI elements appropriately
         * based on the min/max qty 
         * AND if the product has already been 
         * added to cart
         * @param {Object} formObject 
         * @param {Boolean} isIncrement 
         * @param {Boolean} productAddedToCart 
         */
        handleQuantityChange: function(formObject, isIncrement, productAddedToCart) {
            const inputField = formObject.find('.product-quick-buy-txt .form-control');
            const inputValue = isNaN(parseInt(inputField.val())) ? 0 : parseInt(inputField.val());
            const minQty = parseInt(formObject.find('.minQuantity').val());
            let newQuantity = 0;
            if(isIncrement) {
                newQuantity = parseInt(inputValue + minQty);
                inputField.val(newQuantity);
            } else {
                newQuantity = parseInt(inputValue - minQty);
                inputField.val(newQuantity);
            }
            if(productAddedToCart) {
                addToCartStateHandler.setAddedState(formObject);
            } else {
                addToCartStateHandler.setDefaultState(formObject);
            }
        },

        /**
         * Post-success AND no errors
         * Calls the UI handler for added state
         * Refreshes the cart notification icon
         * @param {Object} data 
         * @param {Object} formObject 
         * @param {Object} serializedDataObject 
         */
        ajaxSuccessFlow: function(data, formObject, serializedDataObject) {
            addToCartStateHandler.setAddedState(formObject, data, serializedDataObject);
            COSTCO.Header.miniShopCartRefresh();
             COSTCO.Header.refreshGroceryBanner();
        },

        /**
         * Fetches the error message and passes to UI handler
         * @param {Object} data 
         * @param {Object} formObject 
         */
        ajaxErrorFlow: function(data, formObject) {
            // get the error message here
            const errorMessage = data.orderErrMsgObj === undefined ?
                data.errorMessage : Object.values(data.orderErrMsgObj).toString();
            addToCartStateHandler.setErrorState(formObject, errorMessage);
        },

        /**
         * Sets the UI, constructs a data object
         * makes an ajax call with the data object
         * @param {Event} event
         * @param {Number} index
         * @param {Number} partNumber
         * @param {Number} sku
         */
        addItemToCart: function(event, index, partNumber, sku) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const currentTarget = $(event.target);
            const formObject = currentTarget.closest('form[name=OrderItemAddForm]');
            if(currentTarget.hasClass('disabled')) {
                return false;
            }
            addToCartStateHandler.setAddingState(formObject);
            const inputField = formObject.find('.product-quick-buy-txt .form-control');
            const inputValue = isNaN(parseInt(inputField.val())) ? 0 : parseInt(inputField.val());
            const productObject = addToCartProductObject.constructProductObject(formObject, sku, partNumber);
            const contractIdentifier = productObject.contractIdentifier;
            
            const serializedDataObject = addToCartDataHandler.buildAddToCartForm({
                event: event,
                quantity: inputValue,
                actionType: "add",
                index: index,
                partNumber: partNumber,
                sku: sku,
                contractIdentifier: contractIdentifier
            });
            addToCartDataHandler.makeAjaxCall(serializedDataObject, formObject);
        },

        /**
         * Sets action type, preps data object
         * and makes ajax calls to update cart
         * @param {Event} event 
         * @param {Object} formObject 
         * @param {Number} partNumber 
         * @param {Number} sku 
         * @param {Boolean} isIncrement 
         */
        updateItemToCart: function(event, formObject, partNumber, sku, isIncrement, index) {
            addToCartStateHandler.setAddingState(formObject);
            const actionType = isIncrement === true ? "add" : "update";
            const productObject = addToCartProductObject.constructProductObject(formObject, sku, partNumber);
            const contractIdentifier = productObject.contractIdentifier;
            const newQuantity = isIncrement === true ? productObject.minQty : productObject.quantity
            const serializedDataObject = addToCartDataHandler.buildAddToCartForm({
                event: event,
                quantity: newQuantity,
                actionType: actionType,
                index: index,
                partNumber: partNumber,
                sku: sku,
                contractIdentifier: contractIdentifier
            });
            addToCartDataHandler.makeAjaxCall(serializedDataObject, formObject);
        },
        /**
         * Opens Added to Cart modal
         * data for modal display
         * @param {Object} modalData
         */
        openAddedtoCartModal: function(modalData) {
            COSTCO.dialog.createExtDialogBox({
                title: messages.RELATED_PRODUCT_ADDED_TO_CART,
                body: COSTCO.util.tmpl('tmpl_spinner', {}),
                dialogclasses: 'medium',
            });

            COSTCO.Checkout.ajax_update_state({
                method: 'POST',
                url: '/AjaxAddedToCartView',
                data: {'partNumber': modalData.partNumber},
                dataType: 'json',
                done: function(data, textStatus, jqXHR, options) {
                    COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
                    $('#added-to-cart-modal .quantity-container').html(modalData.quantityAdded);
                    $('#added-to-cart-modal .price-container').html(modalData.price);
                },
                ajax_update_post_done: function(data, textStatus, jqXHR, options) {
                    console.log('Empty implementation. Content replaced.');
                },
            });
        },

        /**
         * Simulates a click to the PDP
         * @param {Event} event 
         */
        openPDP: function(event) {
            const currentTarget = $(event.currentTarget);
            const productTileSet = currentTarget.closest('.product-tile-set');
            const anchorElement = productTileSet.find('.product-image-url');
            $(anchorElement)[0].click();
        },
    
        /**
         * Fixes alignment when compare prods +
         * add to cart button are on the same line
         * This must be done after clearfix hence the timeout
         */
        compareProductsClearfix: function(){
            /* const comparableProducts = Array.from($('.mar_top'));
            comparableProducts.forEach(element => {
                $(element).css('margin-bottom', '10px');
            }) */
        },

        removeItem: function(orderItemId, orderId, isPharmacy, prescriptionId) {
           let params = {
                    ajaxFlag: true,
                    isRestrictedPostalCode: false,
                    actionType: 'delete',
                    orderId: orderId,
                    orderItemId: orderItemId,
                    isPharmacy: isPharmacy,
                    prescriptionId: prescriptionId,
                    lastItemInCart: ""
            };
            COSTCO.AjaxModular.ajax_update_state({
                method: 'POST',
                url: '/AjaxManageShoppingCartCmd',
                data: params,
                dataType: 'json',
                done: function(data, textStatus, jqXHR, options) {
                    if (data.error !== undefined && (data.error.application.length > 0
                            || data.error.exception.length >0)) {
                        displayOrderErrors(data);
                    } else {
                        COSTCO.Header.miniShopCartRefresh();
                    }
				},
            });
        },
        displayOrderErrors: function(data, itemErrorContainer) {
           if (typeof itemErrorContainer !== "undefined" && itemErrorContainer.length > 0) {
                itemErrorContainer.empty();
                if (data.error.application !== undefined) {
                    $.each(data.error.application, function(index, errorMessage) {
                        itemErrorContainer.append(errorMessage);
                    });
                }
                if (data.error.exception !== undefined) {
                    $.each(data.error.exception, function(index, errorMessage) {
                        itemErrorContainer.append(errorMessage);
                    });
                }
                itemErrorContainer.removeClass('hide');
            }
            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application], true, '#notification-message');
        }
    };

    if(typeof window.COSTCO == 'undefined') {
        window.COSTCO = {};
    }

    window.COSTCO.ExtendedAddToCart = ExtendedAddToCart;

    return ExtendedAddToCart;
});


// WEBPACK FOOTER //
// ./js/browse/extendedaddtocart.js